import { ContentCopy } from '@mui/icons-material'
import {
  ButtonCopy,
  ContentBox,
  ContentBoxBody,
  ContentBoxFooter,
  ContentBoxHeader,
  ContentBoxHeaderText,
  ContentCurlRequest,
  ContentCurlRequestBody,
  ContentCurlRequestAttribute,
  ContentCurlRequestString,
  ContentCurlRequestComment,
  ContentCurlRequestCurl,
  ContentCurlRequestHead,
  ContentCurlRequestRow,
  ContentSide,
  StyledSkeleton,
  ContentGroup
} from './styles'
import { useEffect, useRef, useState } from 'react'
import { Tooltip } from '@mui/material'
import stores from '../../../stores/store'

export default function SidebarRight() {
  const { loadingDescription } = stores.DataLoadingStore()
  const { jsonSelected: lang } = stores.DataLocaleStore()
  const { content } = stores.DataContentStore()
  const { urlCurl } = stores.DataUrlCurlStore()
  const { typeCurl } = stores.DataCurlTypeStore()
  const { productTypeCurl } = stores.DataCurlProductTypeStore()
  const { hideHeader } = stores.DataHideHeaderStore()
  const listRef = useRef<HTMLDivElement>(null)

  const buttonRef = useRef<HTMLButtonElement>(null)
  const buttonRefJson = useRef<HTMLButtonElement>(null)
  const [tooltipVisible, setTooltipVisible] = useState(false)
  const [tooltipVisibleJson, setTooltipVisibleJson] = useState(false)
  const [urlDomain, setUrlDomain] = useState('')

  const [jsonResponseText, setJsonResponseText] = useState('')

  useEffect(() => {
    if (content && content.json_response) {
      setJsonResponseText(JSON.stringify(content.json_response, null, 2))
    } else {
      setJsonResponseText('{}')
    }
  }, [content])

  useEffect(() => {
    if (productTypeCurl) {
      let url = process.env.REACT_APP_API_CONSULTA || ''
      url = url.replace('/sandbox', '')
      setUrlDomain(`${url}/${productTypeCurl}${urlCurl}`)
    }
  }, [urlCurl, productTypeCurl])

  const handleCopyCurl = () => {
    let curl = `curl --request ${typeCurl} \\
        --url ${urlDomain} \\
        --header 'Authorization: bearer \${token}' \\
        --header 'accept: application/json' \\
        --header 'content-type: application/json'
      `

    try {
      const textArea = document.createElement('textarea')
      textArea.value = curl
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      setTooltipVisible(true)
      setTimeout(() => setTooltipVisible(false), 2000)
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }

  const handleCopyJson = () => {
    try {
      const textArea = document.createElement('textarea')
      textArea.value = jsonResponseText
      document.body.appendChild(textArea)
      textArea.select()
      document.execCommand('copy')
      document.body.removeChild(textArea)
      setTooltipVisibleJson(true)
      setTimeout(() => setTooltipVisibleJson(false), 2000)
    } catch (err) {
      console.error('Failed to copy: ', err)
    }
  }

  return (
    <>
      <ContentSide ref={listRef} $hideHeader={hideHeader}>
        {loadingDescription ? (
          <StyledSkeleton variant="rectangular" />
        ) : (
          <ContentGroup>
            <ContentBox>
              <ContentBoxHeader>
                <ContentBoxHeaderText>CURL REQUEST</ContentBoxHeaderText>
                <ContentBoxHeaderText>
                  {lang.sidebar.examples}
                </ContentBoxHeaderText>
              </ContentBoxHeader>

              <ContentBoxBody>
                <ContentCurlRequest>
                  <ContentCurlRequestHead>
                    <ContentCurlRequestCurl content="curl" />
                    <ContentCurlRequestAttribute content="--request" />
                    <ContentCurlRequestComment content={`${typeCurl}`} />
                  </ContentCurlRequestHead>
                  <ContentCurlRequestBody>
                    <ContentCurlRequestRow>
                      <ContentCurlRequestAttribute content="--url" />
                      <ContentCurlRequestComment content={urlDomain} />
                    </ContentCurlRequestRow>

                    <ContentCurlRequestRow>
                      <ContentCurlRequestAttribute content="--header" />
                      <ContentCurlRequestString
                        content={String.raw`Authorization: bearer \${token}`}
                      />
                    </ContentCurlRequestRow>

                    <ContentCurlRequestRow>
                      <ContentCurlRequestAttribute content="--header" />
                      <ContentCurlRequestString content="accept: application/json" />
                    </ContentCurlRequestRow>

                    <ContentCurlRequestRow>
                      <ContentCurlRequestAttribute content="--header" />
                      <ContentCurlRequestString content="content-type: application/json" />
                    </ContentCurlRequestRow>
                  </ContentCurlRequestBody>
                </ContentCurlRequest>
              </ContentBoxBody>

              <ContentBoxFooter>
                <Tooltip
                  title={`${lang.sidebar.copied}!`}
                  arrow
                  open={tooltipVisible}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                >
                  <ButtonCopy onClick={handleCopyCurl} ref={buttonRef}>
                    <ContentCopy />
                  </ButtonCopy>
                </Tooltip>
              </ContentBoxFooter>
            </ContentBox>

            <ContentBox>
              <ContentBoxHeader>
                <ContentBoxHeaderText>JSON RESPONSE</ContentBoxHeaderText>
                <ContentBoxHeaderText>
                  {lang.sidebar.examples}
                </ContentBoxHeaderText>
              </ContentBoxHeader>

              <ContentBoxBody $hideHeader={hideHeader}>
                <pre>
                  <code>{jsonResponseText}</code>
                </pre>
              </ContentBoxBody>

              <ContentBoxFooter>
                <Tooltip
                  title={`${lang.sidebar.copied}!`}
                  arrow
                  open={tooltipVisibleJson}
                  disableFocusListener
                  disableHoverListener
                  disableTouchListener
                >
                  <ButtonCopy onClick={handleCopyJson} ref={buttonRefJson}>
                    <ContentCopy />
                  </ButtonCopy>
                </Tooltip>
              </ContentBoxFooter>
            </ContentBox>
          </ContentGroup>
        )}
      </ContentSide>
    </>
  )
}
